module.exports = __webpack_public_path__ + "static/media/ic_cancel_black_18px.cbb473f6.svg";